import { render, staticRenderFns } from "./FiltersModal.vue?vue&type=template&id=a51766da&scoped=true"
import script from "./FiltersModal.vue?vue&type=script&lang=ts"
export * from "./FiltersModal.vue?vue&type=script&lang=ts"
import style0 from "./FiltersModal.vue?vue&type=style&index=0&id=a51766da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51766da",
  null
  
)

export default component.exports